// В.2.c: Синт-кожа (liv_sint_kozha, common Действие, Лив Лайф).
// «Выбранный союзный юнит на поле получит +0/2/0».
//
// Picker: только СВОИ юниты на поле (диздок Лив Лайф). Если своих юнитов
// нет — Действие сгорает «нет цели» (стандартное поведение для других фракций).
//
// Эффект: applyPermanentBuff(target, {armor:2}) — по семантике проекта это
// +2 max_armor + синхронный +2 current_armor. Бафф до конца боя.

import { applyPermanentBuff } from '../../buffs.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

export const CARD_ID = 'liv_sint_kozha';
const LABEL = 'Синт-кожа';

registerImplementedAbility(CARD_ID, 'oneshot');

// Цели picker'а — свои юниты на поле игрока playerIdx.
export function actionTargets(state, playerIdx) {
  const me = state.players?.[playerIdx];
  if (!me) return [];
  return me.unitsOnField().filter(u => u.type === 'unit');
}

export function resolve(state, playerIdx, target /*, opts */) {
  const me = state.players?.[playerIdx];
  // Защита: если своих юнитов нет — сгорает.
  const ownUnits = me ? me.unitsOnField().filter(u => u.type === 'unit') : [];
  if (ownUnits.length === 0) {
    state.log?.add(`📋 ${LABEL}: нет цели — Действие сгорает`);
    return { ok: true, skipped: true };
  }
  // Защита: цель должна быть жива и быть СВОИМ юнитом.
  if (!target || !target.isAlive || !target.isAlive() ||
      target.type !== 'unit' || target.ownerId !== playerIdx) {
    state.log?.add(`📋 ${LABEL}: цель недоступна — Действие сгорает`);
    return { ok: true, skipped: true };
  }
  applyPermanentBuff(state, target, { armor: 2 }, CARD_ID, LABEL);
  return { ok: true };
}
